import React, { createContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';

export const GlobalContext = createContext();

export const GlobalProvider = (props) => {

    function formatRupiah(angka) {
        return new Intl.NumberFormat("id-ID", {
            style: "currency",
            currency: "IDR"
        }).format(angka);
    }

    function setStatusSpan(job_status) {
        if (job_status === 1) {
            return (
                <span className="bg-green-700 text-white text-xs font-semibold mt-[5px] mb-[9px] px-2 py-[1.5px] rounded dark:bg-blue-200 dark:text-blue-800">Open</span>
            )
        } else {
            return (
                <span className="bg-red-700 text-white text-xs font-semibold mt-[5px] mb-[9px] px-2 py-[1.5px] rounded dark:bg-blue-200 dark:text-blue-800">Close</span>
            )
        }
    }
    function longString(str) {
        if (str.length <= 100) {
            return str
        } else if (str === null) {
            return ""
        }
        // Return str truncated with '...' concatenated to the end of str.
        return str.slice(0, 160) + '...'
    };

    function setStatus(job_status) {
        if (job_status === 1) {
            return "Open"
        } else {
            return "Close"
        }
    }

    let navigate = useNavigate();

    const [data, setData] = useState(null)
    const [detail, setDetail] = useState(true)
    const [display, setDisplay] = useState(true)
    const [fetchStatus, setfetchStatus] = useState(true)

    const [input, setInput] = useState(
        {
            title: "",
            job_description: "",
            job_qualification: "",
            job_type: "",
            job_tenure: "",
            job_status: 0,
            company_name: "",
            company_image_url: "",
            company_city: "",
            salary_min: 0,
            salary_max: 0,
        }
    )


    const [currentId, setCurrentId] = useState(-1)

    function singkatString(params) {
        if (params.length === 10) {
            return params
        } else if (params === null) {
            return ""
        }
        // Return params truncated with '...' concatenated to the end of params.
        return params.substring(0, 22) + '...'
        // return params
    }

    const handleInput = (event) => {
        let name = event.target.name;
        let value = event.target.value;

        if (name === "title") {
            setInput({ ...input, title: value });
        } else if (name === "job_description") {
            setInput({ ...input, job_description: value });
        } else if (name === "job_qualification") {
            setInput({ ...input, job_qualification: value });
        } else if (name === "job_type") {
            setInput({ ...input, job_type: value });
        } else if (name === "job_tenure") {
            setInput({ ...input, job_tenure: value });
        } else if (name === "job_status") {
            setInput({ ...input, job_status: value });
        } else if (name === "company_name") {
            setInput({ ...input, company_name: value });
        } else if (name === "company_image_url") {
            setInput({ ...input, company_image_url: value });
        } else if (name === "company_city") {
            setInput({ ...input, company_city: value });
        } else if (name === "salary_min") {
            setInput({ ...input, salary_min: value });
        } else if (name === "salary_max") {
            setInput({ ...input, salary_max: value });
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();

        let { title,
            job_description,
            job_qualification,
            job_type,
            job_tenure,
            job_status,
            company_name,
            company_image_url,
            company_city,
            salary_min,
            salary_max } = input;

        if (currentId === -1) {
            axios.post('https://dev-example.sanbercloud.com/api/job-vacancy', {
                title,
                job_description,
                job_qualification,
                job_type,
                job_tenure,
                job_status,
                company_name,
                company_image_url,
                company_city,
                salary_min,
                salary_max,
            }, { headers: { "Authorization": "Bearer " + Cookies.get('token') } }).then((res) => {
                setfetchStatus(true);
                navigate('/dashboard/list-job-vacancy');
                // console.log(res);
            }).catch((error) => {
                console.log(error);
            });
        } else {
            axios.put(`https://dev-example.sanbercloud.com/api/job-vacancy/${currentId}`, {
                title,
                job_description,
                job_qualification,
                job_type,
                job_tenure,
                job_status,
                company_name,
                company_image_url,
                company_city,
                salary_min,
                salary_max,
            }, { headers: { "Authorization": "Bearer " + Cookies.get('token') } }).then((res) => {
                setfetchStatus(true);
                navigate('/dashboard/list-job-vacancy');
                // console.log(res)
            }).catch((error) => {
                console.log(error);
            });
        }

        setCurrentId(-1);

        setInput(
            {
                title: "",
                job_description: "",
                job_qualification: "",
                job_type: "",
                job_tenure: "",
                job_status: 0,
                company_name: "",
                company_image_url: "",
                company_city: "",
                salary_min: 0,
                salary_max: 0,
            }
        )
    }

    const handleDelete = (event) => {
        let idData = parseInt(event.target.value);

        axios.delete(`https://dev-example.sanbercloud.com/api/job-vacancy/${idData}`, { headers: { "Authorization": "Bearer " + Cookies.get('token') } }).then((res) => {
            setfetchStatus(true);
            navigate('/dashboard/list-job-vacancy');
            // console.log(res);
        });
    }

    const handleEdit = (event) => {
        let idData = parseInt(event.target.value);

        setCurrentId(idData);
        navigate(`/dashboard/list-job-vacancy/form/${idData}`);
    }

    let state = {
        detail,
        setDetail,
        display,
        setDisplay,
        data,
        setData,
        input,
        setInput,
        fetchStatus,
        setfetchStatus,
        currentId,
        setCurrentId
    }

    let handleFunction = {
        setStatusSpan,
        formatRupiah,
        longString,
        setStatus,
        singkatString,
        handleInput,
        handleSubmit,
        handleDelete,
        handleEdit,
    }

    return (
        <GlobalContext.Provider value={{ state, handleFunction }}>
            {props.children}
        </GlobalContext.Provider>
    )
}